import { jsx as _jsx } from "react/jsx-runtime";
import { Link, Tooltip } from '@mui/material';
import { Link as RouterNavLink } from 'react-router-dom';
/**
 * Shows link if sidebar is not collapsed and link with tooltip otherwise.
 *
 * @param collapsed required
 * @param title required
 * @param to required
 * @returns React component
 */
export const SidebarMenuItemLink = ({ collapsed, title, to, children, ...passedProps }) => {
    if (!collapsed)
        return (_jsx(Link, { ...passedProps, component: RouterNavLink, to: to, children: children }));
    return (_jsx(Tooltip, { ...passedProps, arrow: true, title: title, placement: "right", enterDelay: 0, leaveDelay: 0, children: _jsx(Link, { component: RouterNavLink, to: to, children: children }) }));
};
